module.exports = __webpack_public_path__ + "img/promoter.af8f88db.png";